export interface ProductSummary {
  id: string;
  companyId: string;
  eventId: string;
  name: string;
  description: string;
  category: string;
  images: string[];
  tags: string[];
  qrCode?: string;
  barcode?: string;
  price?: string;
  isFavorite?: boolean;
  favoritedAt?: string;
}

export interface FavoriteProductResponse {
  favorited: boolean;
}

export interface ServiceSummary {
  id: string;
  companyId: string;
  eventId: string;
  name: string;
  description: string;
  category: string;
  tags: string[];
  price?: string;
}

export interface CreateServiceInput {
  name: string;
  description?: string;
  category?: string;
  tags?: string[];
  price?: string;
}

export interface UpdateServiceInput extends Partial<CreateServiceInput> {}

export interface RepresentativeSummary {
  id: string;
  companyId: string;
  eventId: string;
  fullName: string;
  position: string;
  photoUrl?: string;
  bio?: string;
  /** Card / MVK phone (also used as fallback for visitors). */
  phone?: string;
  /**
   * Optional override: what visitors see after scanning this badge.
   * When set, prefer over `phone` in visitor UI. Does not change login phone.
   */
  publicPhone?: string;
  email?: string;
  telegram?: string;
  badgeQrCode?: string;
  badgeBarcode?: string;
}

/** Phone to show after badge scan / on personal contacts. */
export function representativeSharePhone(
  rep: Pick<RepresentativeSummary, "phone" | "publicPhone"> | null | undefined,
): string | undefined {
  const pub = (rep?.publicPhone ?? "").trim();
  if (pub) return pub;
  const card = (rep?.phone ?? "").trim();
  return card || undefined;
}

export interface EventSearchResponse {
  companies: import("./auth.js").CompanySummary[];
  products: Array<ProductSummary & { companyName?: string }>;
  services: Array<ServiceSummary & { companyName?: string }>;
  representatives: Array<RepresentativeSummary & { companyName?: string }>;
}
